import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GovermentUniformInvoiceCheckService {

  constructor(private http: HttpClient) { }

  // 有憑證pdf下載 expenseApiUrl
  getGovermentUniformInvoicePdf(param: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/govermentUniformInvoicePdf/bulk`;
    return this.http.post(url, param);
  }

  // 有憑證excel下載  expenseApiUrl
  getGovermentUniformInvoiceExcel(param: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/govermentUniformInvoiceExcel/bulk`;
    return this.http.post(url, param, { responseType: 'blob' });
  }

  //有憑Header查詢 expenseApiUrl
  getGovermentUniformInvoice(govermentUniFormInvoiceRequest: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/searchInvoice`;
    return this.http.post(url, govermentUniFormInvoiceRequest);
  }

  //有憑Detail查詢 expenseApiUrl
  getDetailGovermentUniformInvoiceData(param: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/searchDetailInvoice`;
    return this.http.post(url, param);
  }

  //有憑費用查詢 expenseApiUrl
  getBillingOriginData(param: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/govermentUniformInvoice/searchGovermentBillOrigin`;
    return this.http.post(url, param);
  }

  updateGovermentUniformInvoice(updateList: any): Promise<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/updateInvoice`;
    return this.http.post(url, updateList).toPromise();
  }

  updateDetailGovermentUniformInvoice(updateList: any): Promise<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/updateDetailInvoice`;
    return this.http.post(url, updateList).toPromise();
  }

  sendExpenseDetailToWpgErp(GUIIdList: any[]): Observable<any> {
    const url = `${environment.expenseApiUrl}/govermentUniformInvoice/statementOfAccount`;
    return this.http.post(url, GUIIdList);
  }

  approveGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/gui/approve`;
    return this.http.put(url, updateObj);
  }

  rejectGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/gui/reject`;
    return this.http.put(url, updateObj);
  }

  resendGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/gui/resendErpFlow`;
    return this.http.put(url, updateObj);
  }

  erpFlowGovermentUniformInvoice(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/paymentApplication/gui/erpFlow`;
    return this.http.put(url, updateObj);
  }
}
